import { lazy } from 'react';
import { basename } from '@/fs/resolve';
import type { AppManifest } from '@/apps/types';

/**
 * My Computer / Windows Explorer.
 *
 * Not a singleton: XP happily gave you a window per folder, and the desktop's
 * `My Documents.lnk` and `My Computer.lnk` both point here with different args.
 *
 * Args:
 *   path  string   folder to show; defaults to My Computer
 */
export const explorerApp: AppManifest = {
  id: 'explorer',
  name: 'Windows Explorer',
  icon: '/assets/icons/explorer.svg',
  component: lazy(() => import('./Explorer')),

  defaultSize: { w: 760, h: 520 },
  minSize: { w: 420, h: 300 },
  singleton: false,

  group: 'Accessories',
  titleFor: (args) => basename(String(args.path ?? 'My Computer')) || 'My Computer',
};
